module.exports = __webpack_public_path__ + "img/report-4.448be1b1.jpg";